
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DatePickersMethods extends Vue {
    public datePickers: string[] = [];
    public pickersAutoClose: boolean = true;

    public closeOtherPickers(activePickerRef: string) {
        for (const datePicker of this.datePickers) {
            const pickerElement = (this.$refs[datePicker] as any);

            if (typeof pickerElement !== 'undefined' && pickerElement.pickerOpen && datePicker !== activePickerRef) {
                pickerElement.closePicker();
            }
        }
    }

    public closeTargetedPicker(targetedPickerRef: string) {
        const pickerElement = (this.$refs[targetedPickerRef] as any);

        if (typeof pickerElement !== 'undefined' && pickerElement.pickerOpen && this.pickersAutoClose) {
            pickerElement.closePicker();
        }
    }
}
